import ApiService from '@/core/services/ApiService';
import JwtService from '@/core/services/JwtService';
import requests from '../../requests';

export default {
  uploadImage({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setHeaderPayload('Content-Type', 'multipart/form-data');
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.post(requests.COMMON_UPLOAD_IMAGE, payload.formData, payload.config)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  getSiteConfig({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.COMMON_CONFIG, payload)
        .then(({ data }) => {
          commit('SET_CONFIG', data.data);
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  getNews({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.GET_NEWS, payload)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  findNews({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.FIND_NEWS.replace(":id", payload.id), payload)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  getEvents({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.GET_EVENTS, payload)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  findEvent({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.FIND_EVENT.replace(":id", payload.id), payload)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  getLookups({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.COMMON_LOOKUPS, payload)
        .then(({ data }) => {
          resolve(data);
          commit('SET_LOOKUPS', data.data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
  getCountries({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.setBaseUrl(requests.URL_BASE);
      ApiService.query(requests.COMMON_COUNTRIES, payload)
        .then(({ data }) => {
          resolve(data);
        }).catch((response) => {
        reject(response);
      });
    });
  },
};
